import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
    type RouteableIntent,
} from '../../../';

export interface BrowsePlaylistsPageIntent extends RouteableIntent {
    $kind: IntentKind.BROWSE_PLAYLISTS_PAGE;
    entityPath?: string;
    id?: string;
    metadata?: any;
}

export const isBrowsePlaylistsPageIntent =
    makeIntentGuard<BrowsePlaylistsPageIntent>(
        IntentKind.BROWSE_PLAYLISTS_PAGE,
    );
export const makeBrowsePlaylistsPageIntent =
    makeIntentBuilderFunction<BrowsePlaylistsPageIntent>(
        IntentKind.BROWSE_PLAYLISTS_PAGE,
    );
